import React from 'react';
import styled from 'styled-components';
import { onLightTheme } from 'students/views/shared/styled';

const ASSIGNMENTS_ICON_GRADIENT = 'navigationAssignmentsGradient';

const AssignmentsIconSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SPath d="M19.4596 12.9163C20.2574 12.117 21.0415 12.3334 21.4702 12.7621L22.5527 13.8445C23.1498 14.4412 23.1498 15.4119 22.5527 16.0094L16.0553 22.5068C15.9609 22.602 15.8386 22.6659 15.7058 22.6887L13.0764 23.1524C13.0387 23.1594 12.9999 23.1631 12.9622 23.1631C12.7899 23.1631 12.6219 23.0947 12.4986 22.9705C12.3472 22.8191 12.2791 22.6036 12.3167 22.3918L12.7803 19.7624C12.8031 19.6304 12.8679 19.5081 12.9622 19.4128L19.4596 12.9163ZM14.4691 2.16309C15.7991 2.16309 16.8756 3.23963 16.8756 4.56963V13.0304L11.722 18.1752C11.372 18.534 11.1443 18.9719 11.0568 19.4619L10.8642 20.5381H4.40701C3.07702 20.5381 2.00049 19.4615 2.00049 18.1315V4.56963C2.00049 3.23963 3.07702 2.16309 4.40701 2.16309H14.4691ZM5.50015 12.6631C5.01914 12.6632 4.62562 13.0568 4.62546 13.5378C4.62546 14.0189 5.01904 14.4132 5.50015 14.4134H9.8754C10.3566 14.4134 10.7501 14.019 10.7501 13.5378C10.7499 13.0567 10.3565 12.6631 9.8754 12.6631H5.50015ZM5.50015 9.16338C5.01904 9.16355 4.62546 9.55694 4.62546 10.0381C4.62546 10.5192 5.01904 10.9126 5.50015 10.9128H13.3751C13.8563 10.9128 14.2507 10.5193 14.2507 10.0381C14.2507 9.55684 13.8563 9.16338 13.3751 9.16338H5.50015ZM5.50015 5.66279C5.01904 5.66295 4.62546 6.05723 4.62546 6.53838C4.62562 7.0194 5.01914 7.41292 5.50015 7.41309H9.00071C9.48172 7.41292 9.87524 7.0194 9.8754 6.53838C9.8754 6.05723 9.48182 5.66295 9.00071 5.66279H5.50015Z" />
      <defs>
        <linearGradient
          id={ASSIGNMENTS_ICON_GRADIENT}
          x1="12.5005"
          y1="25.5312"
          x2="3.69438"
          y2="1.18318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6817FF" />
          <stop offset="1" stopColor="#B98DFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AssignmentsIconSvg;

const SPath = styled.path`
  fill: #a5aac5;

  ${onLightTheme`
    fill: rgb(var(--ln-content) / 0.6);
  `}

  .active & {
    fill: url(#${ASSIGNMENTS_ICON_GRADIENT});
  }
`;
